import { onMount } from "@/modules/_";
import gsap from "@lib/gsap";

export default function (element: HTMLElement, dataset: DOMStringMap) {
  onMount(() => {
    const parallaxValue = element.getAttribute("data-parallax");
    const speed = element.getAttribute("data-parallax-speed");

    if (!parallaxValue) return;

    gsap.to(element, {
      yPercent: Number(parallaxValue) * 100,
      ease: "none",
      scrollTrigger: {
        trigger: element,
        start: "top bottom",
        end: "bottom top",
        scrub: speed ? Number(speed) : true,
        // markers: true,
      },
    });
  });
}
